import Utils from './utils.js';

import DarkMode from './components/dark-mode.js';
import AdInjector from './modules/ad-injector.js';
import StickyHeader from './modules/sticky-header.js';
import PostFilter from './modules/post-filter.js';	
import BranditPostsLazyLoader from './components/brandit-posts-lazy-loader.js';
import ReadPostsTracker from './modules/read-posts-tracker.js';
import HeaderSubmenu from './components/header-submenu.js';

document.addEventListener("DOMContentLoaded", function (e) {

	if (!e.isTrusted) return;

	const mobileMenuButton = document.querySelector('#mobileNavmenuOpen');
	if (mobileMenuButton) {
		mobileMenuButton.addEventListener("click", async () => {
			if (!mobileMenuButton.dataset.mobileHeaderLoaded) {
				try {
					const { default: MobileHeader } = await import('./components/header-mobile.js');
					MobileHeader.init();
					mobileMenuButton.dataset.mobileHeaderLoaded = 'true';
					mobileMenuButton.click();
				} catch (error) {
					console.error('Chyba pri načítaní MobileHeader:', error);
				}
			}
		});
	}

	if (typeof DarkMode !== 'undefined') {
		DarkMode.init();
	}

	// Convert quick news timestamps to relative time
	const timestampTagsToConvert = [...document.querySelectorAll('.time-to-relative')]

	timestampTagsToConvert.forEach((element) => {
		const time = element.dataset.timestamp || 0
		const relativeTime = Utils.getRelativeTimestamp(time) || ""
		element.textContent = relativeTime
	});

	// Convert quick news items to collapsible
	const quickNewsItems = document.querySelectorAll('.quick-news-single__body-text');

	quickNewsItems.forEach((item) => {
		Utils.makeItemCollapsibleByWords(item, 60);
	});

	const postContentImages = document.querySelectorAll('.wp-block-image');

	if (postContentImages.length > 0) {
		import('glightbox').then(({ default: GLightbox }) => {
			postContentImages.forEach((image) => {
				const link = image.querySelector('a');
				if (link) {
					link.classList.add('glightbox');
					link.setAttribute('data-type', 'image');
					link.setAttribute('data-gallery', 'post-images');
				}
			});

			const _lightbox = GLightbox({
				selector: '.wp-block-image .glightbox',
				loop: true,
				openEffect: "fade",
				closeEffect: "fade",
				width: "90vw",
			});
		}).catch((error) => {
			console.error('Chyba pri načítaní GLightbox:', error);
		});
	}

	const searchButton = document.getElementById("toggleLargeSearchbox");
	if (searchButton) {
		searchButton.addEventListener("click", async () => {
			if (!searchButton.dataset.searchLoaded) {
				try {
					const { default: SearchBox } = await import('./components/search-box.js');
					SearchBox.init();
					searchButton.dataset.searchLoaded = 'true';
					searchButton.click();
				} catch (error) {
					console.error('Chyba pri načítaní SearchBox:', error);
				}
			}
		});
	}

	PostFilter.init();
	AdInjector.init();
	
	// Initialize Newsletter only if newsletter form is present on page
	const newsletterForm = document.querySelector('.newsletter-form');
	if (newsletterForm) {
		import('./components/newsletter.js').then(({ default: Newsletter }) => {
			Newsletter.init();
		}).catch((error) => {
			console.error('Chyba pri načítaní Newsletter:', error);
		});
	}

	const authorArticles = document.querySelector('.author-articles');
	if (authorArticles) {
		import('./modules/author-infinite-scroll.js').then(({ default: AuthorInfiniteScroll }) => {
			AuthorInfiniteScroll.init();
		}).catch((error) => {
			console.error('Chyba pri načítaní AuthorInfiniteScroll:', error);
		});
	}
	
	StickyHeader.init();

	BranditPostsLazyLoader.init();

	ReadPostsTracker.init();

	HeaderSubmenu.init();

}
);